/* RESPONSIBLE TEAM: team-ai-agent */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type AiAgentSetupService from 'embercom/services/ai-agent-setup-service';
import type FinVoiceConfigService from 'embercom/services/fin-voice-config-service';

export default class FinAIAgentDeployPhoneRoute extends Route {
  @service declare intl: IntlService;
  @service declare finVoiceConfigService: FinVoiceConfigService;
  @service declare aiAgentSetupService: AiAgentSetupService;

  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.deploy.phone',
  };

  queryParams = {
    tab: {
      refreshModel: true,
    },
  };

  get titleToken() {
    return this.intl.t('ai-agent.deploy.phone');
  }

  async model() {
    this.aiAgentSetupService.channelType = 'phone';

    return {
      hasSomePhoneFeaturesEnabled: await this.finVoiceConfigService.canAccessFinVoice(),
    };
  }
}
